import { render, staticRenderFns } from "./WorkloadWidgetComponent.vue?vue&type=template&id=5a459f8a&scoped=true&"
import script from "./WorkloadWidgetComponent.vue?vue&type=script&lang=ts&"
export * from "./WorkloadWidgetComponent.vue?vue&type=script&lang=ts&"
import style0 from "./WorkloadWidgetComponent.vue?vue&type=style&index=0&id=5a459f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a459f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
